import React, { lazy, Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/UI/Button';
// Social Media Button Component - reusable for all spotlight features
const SocialButton = ({
  url,
  platform
}: {
  url: string;
  platform: string;
}) => {
  // Detect platform from URL
  const getPlatformInfo = (url: string) => {
    const lowerUrl = url.toLowerCase();
    if (lowerUrl.includes('linkedin.com')) {
      return {
        name: 'LinkedIn',
        bgColor: 'bg-[#0A66C2]',
        hoverColor: 'hover:bg-[#004182]',
        icon: <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-2435">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-2436" />
          </svg>
      };
    }
    if (lowerUrl.includes('instagram.com')) {
      return {
        name: 'Instagram',
        bgColor: 'bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737]',
        hoverColor: 'hover:opacity-90',
        icon: <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-2437">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" data-id="element-2438" />
          </svg>
      };
    }
    if (lowerUrl.includes('twitter.com') || lowerUrl.includes('x.com')) {
      return {
        name: 'X (Twitter)',
        bgColor: 'bg-black',
        hoverColor: 'hover:bg-gray-800',
        icon: <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-2439">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-2440" />
          </svg>
      };
    }
    if (lowerUrl.includes('facebook.com')) {
      return {
        name: 'Facebook',
        bgColor: 'bg-[#1877F2]',
        hoverColor: 'hover:bg-[#0d65d9]',
        icon: <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-2441">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-2442" />
          </svg>
      };
    }
    if (lowerUrl.includes('youtube.com')) {
      return {
        name: 'YouTube',
        bgColor: 'bg-[#FF0000]',
        hoverColor: 'hover:bg-[#cc0000]',
        icon: <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-2443">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-2444" />
          </svg>
      };
    }
    if (lowerUrl.includes('tiktok.com')) {
      return {
        name: 'TikTok',
        bgColor: 'bg-black',
        hoverColor: 'hover:bg-gray-800',
        icon: <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-2445">
            <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" data-id="element-2446" />
          </svg>
      };
    }
    // Default website
    return {
      name: 'Website',
      bgColor: 'bg-gray-700',
      hoverColor: 'hover:bg-gray-600',
      icon: <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-2447">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" data-id="element-2448" />
        </svg>
    };
  };
  const platformInfo = getPlatformInfo(url);
  return <a href={url} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center px-4 py-2 rounded-lg text-white font-medium transition-all ${platformInfo.bgColor} ${platformInfo.hoverColor}`} data-id="element-2449">
      {platformInfo.icon}
      Connect on {platformInfo.name}
    </a>;
};
export const AugustineSpotlight = () => {
  // Social media links for this feature
  const socialLinks = ['https://www.instagram.com/themichanic_?igsh=MXVmbGd3cjltMmQ0OQ%3D%3D&utm_source=qr'];
  return <div className="pt-20 bg-white min-h-screen" data-id="element-2450">
      {/* Hero Section */}
      <section className="relative py-16 border-b border-gray-200" data-id="element-2451">
        <div className="absolute inset-0 z-0" data-id="element-2452">
          <img src="https://cdn.magicpatterns.com/uploads/9umWqNKiHbUDpxfJtwUhB7/2.png" alt="Augustine Aigbokhaevbo" className="w-full h-full object-cover" loading="lazy" data-id="element-2453" />
          <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-2454"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-2455">
          <div className="max-w-4xl mx-auto" data-id="element-2456">
            <Link to="/salon-spotlight" className="inline-flex items-center text-white hover:text-gray-200 mb-6" data-id="element-2457">
              <ArrowLeft size={20} className="mr-2" data-id="element-2458" />
              Back to Salon Spotlight
            </Link>
            <div className="text-white" data-id="element-2459">
              <p className="text-sm mb-4" data-id="element-2460">SALON SPOTLIGHT</p>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-2461">
                Augustine Aigbokhaevbo
              </h1>
              <p className="text-2xl md:text-3xl font-medium" data-id="element-2462">
                The Voice That Holds the Room—and the Moment
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16" data-id="element-2463">
        <div className="container mx-auto px-4" data-id="element-2464">
          <div className="max-w-4xl mx-auto" data-id="element-2465">
            <article className="prose prose-lg max-w-none" data-id="element-2466">
              <p className="text-xl text-gray-700 leading-relaxed mb-8" data-id="element-2467">
                Some people don't just speak into microphones. They hold space.
                They read the room, feel the tension, sense the silence, and
                guide moments with intention. Augustine Aigbokhaevbo is one of
                those people.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2468">
                A professional Master of Ceremonies and public speaker with over
                nine years of experience, Augustine works at the intersection of
                communication, emotional intelligence, and audience psychology.
                Through Flex 360 Degree Ltd, he helps brands, corporate
                organisations, and premium clients transform events into
                meaningful experiences—ones that linger long after the lights go
                out.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2469">
                His Story: From Loving Conversations to Leading Rooms
              </h2>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2470">
                Augustine's journey began simply: he loved talking to people.
                More accurately, he loved listening. Early on, he understood
                something many overlook—that humanity's deepest need is to be
                understood. That insight shaped everything that followed.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2471">
                While studying at DELSU Abraka, he naturally gravitated toward
                roles that required presence, clarity, and direction. Hosting
                events wasn't just performance for him; it was stewardship. The
                real turning point came when he encountered Joyce Daniels, who
                later became his mentor, coach, and trainer. Seeing her journey
                helped him realise that passion could be professionalised—that
                communication, when mastered, could become a powerful and viable
                craft.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2472">
                The Work: Curating Flow, Meaning, and Memory
              </h2>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2473">
                Augustine describes his work as protecting the flow of events.
                He designs, manages, and delivers high-level experiences by
                ensuring that every moment aligns with the client's intent and
                brand. Drawing from emotional intelligence, creative
                communication, and deep audience awareness, he doesn't just keep
                events moving—he makes them matter.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2474">
                For him, events are cultural landmarks. They are moments where
                people gather, feel, decide, and remember. When he insists on
                challenging the status quo—always with reason—it's in service of
                elevating standards and redefining what excellence looks like in
                public experiences.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2475">
                Culture, Impact, and Why This Matters
              </h2>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2476">
                Augustine's work extends beyond hosting. He sees speaking as an
                outlet for voice—his own and others'. Even while anchoring
                events, he sparks intelligent conversations that ripple into
                post-event reflection and insight. In doing so, he contributes
                quietly but deliberately to culture.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2477">
                One defining moment still stays with him: hosting a wedding
                where the father of the bride, a Major, publicly slapped the
                groom and walked out. What could have collapsed into chaos
                became a lesson in emotional regulation. By focusing on what was
                wrong rather than who was wrong, Augustine steadied the moment.
                The event continued as though nothing had happened. Years later,
                the couple still thanks him—not for speaking well, but for
                holding the moment when it mattered most.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2478">
                That experience confirmed what he already knew: being an MC is
                never just about holding a microphone. It's about
                responsibility.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2479">
                What He's Building and Open To
              </h2>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2480">
                Augustine is open to all speaking opportunities—conferences,
                workshops, radio, TV, keynote sessions, and beyond. After more
                than a decade committed to learning, observation, and
                intelligentsia, he's ready to share what he knows, not just
                about speaking, but about life, presence, and intentionality.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2481">
                His influences span generations and disciplines—from Joyce
                Daniels and Alibaba to Trevor Noah, Larry King, and Dave
                Chappelle—voices that understand that communication is both
                craft and calling.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2482">
                Words He Lives By
              </h2>

              <p className="text-xl text-gray-700 leading-relaxed font-medium italic border-l-4 border-gray-300 pl-6 my-12" data-id="element-2483">
                "Success is an accumulation of your daily routine, not just a
                high point of your career."
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2484">
                Augustine believes clarity must come before movement, that peace
                with your why anchors every journey, and that leveraging shared
                knowledge and experience helps us avoid cycles others have
                already escaped.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-2485">
                Why We Spotlight Him
              </h2>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2486">
                Augustine embodies what The Networking Salon stands for:
                intentional communication, emotional intelligence, service, and
                presence. He reminds us that everyday interactions are also
                events—and how we show up in them shapes lives.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-2487">
                This spotlight celebrates not just what he does, but how he does
                it: with care, clarity, and a deep respect for human connection.
              </p>
            </article>

            {/* Connect Section */}
            <div className="mt-12 p-8 bg-gray-50 rounded-lg border-2 border-gray-200" data-id="element-2488">
              <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2489">
                Connect with Augustine
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-2490">
                Reach out to Augustine for speaking opportunities,
                collaborations, or to learn more about his work.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-2491">
                {socialLinks.map((link, index) => <SocialButton key={index} url={link} platform="" data-id="element-2492" />)}
              </div>
            </div>

            {/* Back Button */}
            <div className="mt-16 pt-8 border-t-2 border-gray-300" data-id="element-2493">
              <Link to="/salon-spotlight" data-id="element-2494">
                <Button variant="outline" data-id="element-2495">
                  <ArrowLeft size={20} className="mr-2" data-id="element-2496" />
                  Back to Salon Spotlight
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
};